/**
 * @license
 * @copyright Copyright Motili Inc., 2017 All Rights Reserved
 */

import classNames from 'classnames';

/**
 * @param {string} [controlId='form-checkbox']
 * @param {string} [name]
 * @param {boolean} [checked=false]
 * @param {Function} [onClick]
 * @param {Function} [onChange]
 * @param {boolean} [disabled]
 * @param {boolean} [uncontrolled=false]
 * @param {Object} [style]
 * @param {boolean} [header=false]
 * @param {React.Ref} ref
 */
function FormCheckboxNoLabel({
    controlId = 'form-checkbox',
    name,
    checked = false,
    onClick,
    onChange,
    disabled,
    uncontrolled = false,
    style = { width: '100%' },
    header = false,
    ref,
}) {
    return (
        <div
            className={classNames({
                'motili-checkbox': true,
                'motili-checkbox-noLabel': header,
            })}
            style={style}
        >
            <input
                type='checkbox'
                id={controlId}
                name={name}
                checked={uncontrolled ? undefined : checked}
                onClick={onClick}
                onChange={onChange}
                disabled={disabled}
                ref={ref}
            />
            <label htmlFor={controlId} />
        </div>
    );
}
export default FormCheckboxNoLabel;
